import { type ReactNode, createContext, useState } from "react";

export const UploadProgressContext = createContext<{
	getProgress: (uploadId: string) => number | undefined;
	setProgress: (uploadId: string, progress?: number | undefined) => void;
}>({ getProgress: () => undefined, setProgress: () => {} });

export function UploadProgressProvider({ children }: { children: ReactNode }) {
	const [toasts, setToasts] = useState<Record<string, number>>({});

	const setProgress = (uploadId: string, progress: number | undefined) => {
		if (!progress) {
			setToasts((prev) => {
				const { [uploadId]: _, ...rest } = prev;

				return rest;
			});
		} else {
			setToasts((prev) => ({ ...prev, [uploadId]: progress }));
		}
	};

	const getProgress = (uploadId: string) => toasts[uploadId];

	return (
		<UploadProgressContext.Provider value={{ getProgress, setProgress }}>
			{children}
		</UploadProgressContext.Provider>
	);
}
